const route = {
  title: 'Receivable Address',
  path: '/ar/addresses/:id',
  scopes: ['ar.manage'],
  menuGroup: null,
}

export const ArAddressFormPage = createPage(route, () => {
  return pug`
    Main
      .min-h-full.p-2.col.center
        Icon.h-20.text-red-800.opacity-50(icon='times-circle')
  `
})
